export const localStorageKeys = {
  DISABLE_ALL_DEBUGGING: "DISABLE_ALL_DEBUGGING", // for disabling all debugging features in debug mode
  TEMP_API_SERVER: "TEMP_API_SERVER", // for setting custom env for APIs
  TEMP_SSO_ENABLED: "TEMP_SSO_ENABLED", // [TO-BE-REMOVED] for setting to enabling SSO login in debug mode
  // [TO-BE-REMOVED] -- items commented below are good for removal --
  // TEMP_SSO_BE_API_BYPASS_EMAIL: "TEMP_SSO_BE_API_BYPASS_EMAIL", // [TO-BE-REMOVED] for setting email to bypass BE API calls in SSO login flow in debug mode
  // TEMP_SSO_BE_API_BYPASS_PASSWORD: "TEMP_SSO_BE_API_BYPASS_PASSWORD", // [TO-BE-REMOVED] for setting password to bypass BE API calls in SSO login flow in debug mode
  TEMP_PHONE_COUNTRY_CODE: "TEMP_PHONE_COUNTRY_CODE", // for setting custom country code for phone number
  TEMP_DASH_FILTERS_DATE: "TEMP_DASH_FILTERS_DATE", // for debugging dashboard widgets with old date
  columns: {
    Users: "columnsUsers",
    Roles: "columnsRoles",
    Vehicles: "columnsVehicles",
    Groups: "columnsGroups",
    Fleettags: "columnsFleettags",
    Drivers: "columnsDrivers",
    Geozones: "columnsGeozones",
    GeozoneCategories: "columnsGeozoneCategories",
    VehicleAlerts: "columnsVehicleAlerts",
    BuzzerAlerts: "columnsBuzzerAlerts",
    ReportsPrefix: "columnsReports", // to check if a key is a report column key
    Reports: (type: string, category: string, reportId: string) =>
      `columnsReports_${type}_${category}_${reportId}`,
    ReportsSharing: (type: string, category: string, reportId: string) =>
      `columnsReportsSharing_${type}_${category}_${reportId}`,
    Rules: "columnsRules",
    Maintenance: "columnsMaintenance",
    IncidentReview: "columnsIncidentReview",
    CrashTrack: "columnsCrashTrack",

    Enterprises: "columnsEnterprises",
    EnterprisesUsers: "columnsEnterprisesUsers",
    CameraManagement: "columnsCameraManagement",
    CameraListingWidget: "columnsCameraListingWidget",
    CameraVideoHistoryEvents: "columnsCameraVideoHistoryEvents",
    FileRetrieval: "columnsFileRetrieval",
  },
  // color mode (dark, colored, scrolling) per standard report identifier
  reportColorMode: (reportIdentifier: string) =>
    `reportColorMode_${reportIdentifier}`,
  accessToken: "accessToken",
  loggedInUserData: "loggedInUserData",
  ownerOrganization: "ownerOrganization",
  user: "user",
  user_auth_type: "user_auth_type",
  user_profile: "user_profile",
  pageBeforeSessionExpire: "pageBeforeSessionExpire",
  sessionGotExpired: "sessionGotExpired",

  chatPresence: "chatPresence",

  camerasAdminVMAPIURLBase: "camerasAdminVMAPIURLBase",
  camerasAdminVMAPIKey: "camerasAdminVMAPIKey",
  camerasAdminVMToken: "camerasAdminVMToken",
  summaryProcessCompleteTimeUtc: "summaryProcessCompleteTimeUtc",

  azureIdToken: "azureIdToken",
  azureTokenExpiry: "azureTokenExpiry",
};

export const useLocalStorage = () => {
  const setLocalStorageItem = (itemKey: string, itemValue: object | string) => {
    localStorage.setItem(
      itemKey,
      typeof itemValue == "object" ? JSON.stringify(itemValue) : itemValue
    );
  };
  const getLocalStorageItem = (itemKey: string) => {
    const value = localStorage.getItem(itemKey);
    return ["{", "["].includes(`${value?.charAt(0)}`) || value === "null"
      ? JSON.parse(`${value}`)
      : value;
  };
  const removeLocalStorageItem = (itemKey: string) => {
    localStorage.removeItem(itemKey);
  };

  return {
    setLocalStorageItem,
    getLocalStorageItem,
    removeLocalStorageItem,
  };
};
